import { render, staticRenderFns } from "./ItensDefeituosos.vue?vue&type=template&id=7ea61b8f&"
import script from "./ItensDefeituosos.vue?vue&type=script&lang=js&"
export * from "./ItensDefeituosos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports